"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function BudgetBlueSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 68, height: 43, viewBox: "0 0 68 43" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `budgetblue-${id0}`, d: "M5.833.833l.001 2.541c1.618.162 2.91.798 3.867 1.776l-.996 1.179c-.996-1.083-2.39-1.546-3.844-1.546-1.574 0-2.73.83-2.73 2.048C2.131 9.729 10 8.068 10 12.879c0 1.723-1.133 3.512-4.165 3.759l-.002 2.529H4.167v-2.55C2.337 16.42.94 15.647 0 14.618l.996-1.236c.857.966 2.29 1.855 4.163 1.855 2.37 0 3.128-1.237 3.128-2.242 0-3.324-7.869-1.468-7.869-6.067 0-1.894 1.55-3.267 3.748-3.543V.833h1.667z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", null,
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("g", null,
                            react_1.default.createElement("g", null,
                                react_1.default.createElement("g", { transform: "translate(-1068 -494) translate(848 20) translate(31 129) translate(0 260) translate(188 84) translate(1 1)" },
                                    react_1.default.createElement("rect", { width: 54, height: 14, x: 7, y: 14, fill: "#597EFF", fillRule: "nonzero", opacity: 0.1, rx: 2 }),
                                    react_1.default.createElement("path", { fill: "#597EFF", fillRule: "nonzero", d: "M17 21H29V23H17zM12 21H15V23H12z", opacity: 0.4 }),
                                    react_1.default.createElement("g", { opacity: 0.6, transform: "translate(45 11)" },
                                        react_1.default.createElement("use", { fill: "#597EFF", xlinkHref: `#budgetblue-${id0}` }))))))))));
}
function BudgetBlue(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(BudgetBlueSvg, Object.assign({}, svgProps)));
}
exports.default = BudgetBlue;
//# sourceMappingURL=BudgetBlue.js.map